module.exports = __webpack_public_path__ + "img/ShieldTestDetails-min.a2622526.png";